import React from 'react'
import rightArrow from '../../assets/images/arrow_right_grey.png'
import upTrendArrow from '../../assets/images/increase.png'
import downTrendArrow from '../../assets/images/decrease.png'
import upArrow from '../../assets/images/arrow_up.png'
import downArrow from '../../assets/images/arrow_down.png'
interface CardProps {
  props: {
    title: string;
    value: string;
    change: number;
    isChangePositive?: boolean;
    recordName?: string;
  }
}
function KPICard({ props }: CardProps) {
  const { title, value, change, isChangePositive, recordName } = props;
  return (
    <div className='p-6 rounded-lg bg-light hover:scale-[1.02] transform transition duration-200 ease-out'>

      <div className="grid grid-cols-2 lg:gap-4 gap-2 mb-4">
                {/* left side */}
        <div>
          <h3 className="text-md mb-2 text-grey_dark">{title}</h3>
          <h2 
            className={`text-lg mb-2 text-dark truncated-figure-md`}
            title={value}
          >
            {value}
          </h2>
          {/* Change indicator */}
          <div className="flex items-center mb-2">
            {isChangePositive ? (
              <img src={upArrow} alt="increase" className="h-5 w-5 text-primary" />
            ) : (
              <img src={downArrow} alt="decrease" className="h-5 w-5 text-danger" />
            )}
            <p className={`text-sm font-medium ${isChangePositive ? 'text-primary' : 'text-danger'}`}>{change}%</p>
          </div>
        </div>

        {/* right side */}
        <div className="flex items-center justify-center">
          <img src={isChangePositive ? upTrendArrow : downTrendArrow} alt="info" className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24" />
        </div>
      </div>
      <hr className="my-2 border-grey_light" />
      <div className="text-sm text-grey_dark flex items-center justify-between">
        {recordName} record
        <img src={rightArrow} alt="info" className="inline-block ms-1 h-4 w-4" />
      </div>

    </div>
  )
}

export default KPICard